export const FETCH_PLANTS = '@@plants/fetch-plants';
export const FETCH_PLANTS_SUCCESS = '@@plants/fetch-plants-success';
export const FETCH_PLANTS_FAILURE = '@@plants/fetch-plants-failure';
